/**
 * Shared label-uniqueness helper used by both the electron IPC layer and the
 * renderer (AddLinkedDbDialog). Centralised here so both sides apply the same
 * case-insensitive uniqueness rule without duplicating logic.
 *
 * Rule: two labels are considered the same if they are equal after calling
 * `.toLowerCase()`. User-visible casing is always preserved — only the
 * uniqueness check is case-insensitive.
 */

/**
 * Returns `true` when `candidate` already appears in `labels` using a
 * case-insensitive comparison. Does NOT mutate or lowercase any stored label.
 */
export function existsByLabel(
  labels: ReadonlyArray<{ label: string }>,
  candidate: string,
): boolean {
  const c = candidate.toLowerCase();
  return labels.some((l) => l.label.toLowerCase() === c);
}
